// extracted by mini-css-extract-plugin
export default {"effect":"ShimmerEffect_effect__JYqR3","shimmer":"ShimmerEffect_shimmer__cQJfp"};